module.exports = __webpack_public_path__ + "static/media/foody-delivery.3b5e978c.webp";